import React, { createContext, Fragment, useContext, useState } from "react";
import { IntlProvider } from "react-intl";
import messages from "./messages";
import { LOCALES } from "./locales";
import {useSelector} from "react-redux";

const LangContext = createContext({
  user: null,
  isAuthenticated: false,
  isLoading: true,
});

export const useLocale = () => useContext(LangContext);

export default function Provider({ children }) {
  const {lang}=useSelector(state=>state.lang)

  return (
    <LangContext.Provider
      value={{

      }}
    >
      <IntlProvider
        locale={lang}
        textComponent={Fragment}
        messages={messages[lang]}
      >
        {children}
      </IntlProvider>
    </LangContext.Provider>
  );
}
